var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaq30X37 = function SvgFaq30X37(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.97 22.338c0-6.033 6.432-7.828 6.432-10.87 0-1.545-1.496-2.343-3.34-2.343-2.145 0-4.14 1.296-5.187 3.39L0 8.078C2.543 3.29 7.58 0 15.557 0c7.828 0 13.662 3.29 13.662 9.524 0 7.629-7.978 8.975-7.978 12.814zM16.105 36.2c-3.889 0-6.581-2.693-6.581-5.984 0-3.34 2.692-5.883 6.582-5.883s6.581 2.543 6.581 5.884c0 3.29-2.692 5.983-6.582 5.983"
  })));
};
export default SvgFaq30X37;